import { useEffect, useRef } from "react";
import { useSignalR } from "../../context/signalRContext";

// sample usage:

// 1 message type + handler
// useSignalRListener({
//     type: SIGNALR_MESSAGE_TYPE.SUCCESS,
//     handler: (msg) => toast.success(msg),
// });

// multiple message type  + handler
// useSignalRListener([
//     {
//         type: SIGNALR_MESSAGE_TYPE.ERROR,
//         handler: (msg) => toast.error(msg),
//     },
//     {
//         type: SIGNALR_MESSAGE_TYPE.SUCCESS,
//         handler: (msg) => toast.success(msg),
//     },
// ]);

export const useSignalRListener = (input, options = {}) => {
    const connection = useSignalR();
    const handlersRef = useRef({});

    useEffect(() => {
        if (!connection || !input) return;

        const listeners = Array.isArray(input) ? input : [input];

        listeners.forEach(({ type, handler }) => {
            const wrappedHandler = (payload) => {
                let parsed = payload;
                if (payload && typeof payload === "string") {
                    try {
                        parsed = JSON.parse(payload);
                    } catch (err) {
                        console.error("Failed to parse SignalR payload.msg:", err);
                    }
                }

                if (options.debounceMs) {
                    clearTimeout(handlersRef.current[type]);
                    handlersRef.current[type] = setTimeout(() => {
                        handler(parsed);
                    }, options.debounceMs);
                } else {
                    handler(parsed);
                }
            };

            connection.on(type, wrappedHandler);
            handlersRef.current[type] = wrappedHandler;
        });

        return () => {
            listeners.forEach(({ type }) => {
                connection.off(type, handlersRef.current[type]);
                clearTimeout(handlersRef.current[type]);
            });
        };
    }, [connection, input, options.debounceMs]);
};
